// organizationRole
// 角色管理
import layout from '@/layout/index.vue'
export default {
  path: '/organization',
  component: layout,
  name: 'organizationRole',
  redirect: '/organization/role',
  meta: {
    title: '组织架构',
    icon: 'zuzhi'
  },
  children: [
    {
      path: '/organization/role',
      component: () => import('@/views/organization/role/index.vue'),
      meta: {
        title: '角色管理',
        icon: 'zuzhi'
      }
    }
  ]
}
